<template>
    <li class="widget__list__option">
        <router-link
            class="widget__list__option__anchor position--relative accessibility--pseudo accessibility--pseudo--default"
            :to="settings.url"
        >
            {{ $t(`global.${settings.label}`) }}
        </router-link>
    </li>
</template>

<script>
export default {
    props: {
        settings: {
            type: Object,
            default: () => ({ url: '', label: '' })
        }
    }
};
</script>